import {Component, Input, OnInit,} from '@angular/core';
import * as _ from "underscore";
import * as _sh from 'lodash';
import {DataCenterService} from "../../../service/data-center.service";
import {forkJoin as observableForkJoin} from "rxjs";
import {AppConfigService} from "../../../service/app-config.service";
import {RequestDataService} from "../../../service/request-data.service";
import {UtilsService} from "../../../service/utils.service";
import {ConfirmModalService} from "../../../service/confirm-modal.service";
import {NzModalService} from "ng-zorro-antd";
import {UserInfoService} from "../../../service/user-info.service";

@Component({
    selector: 'app-tran-business-target',
    templateUrl: './tran-business-target.component.html',
    styleUrls: ['./tran-business-target.component.scss']
})
export class TranBusinessTargetComponent implements OnInit {

  @Input() parentData;

  msTranBusinessTargetForm: any = {
    "tablename": "ms_tran_business_target",
    "formname": "ms_tran_business_target",
    "title": "配送目标管理",
    "type": "normal",
    "add_link": null,
    "modify_link": "JieLiv2/ms/tran_business_target_detail.json",
    "columns": [
      {
        "column": "TARGET_ID",
        "pk_column": true,
        "iscondition": true,
        "name": "TARGET_ID_NAME",
        "component": "input",
        "lable": "主键",
        "comment": "主键",
        "placeholder": "主键",
        "insertValue": "SYS-ACTION-UUID",
        "model": "",
        "visible": false,
        "require": false
      },
      {
        "column": "YEAR_MONTH_START",
        "name": "YEAR_MONTH_START_NAME",
        "component": "dateMonths",
        "lable": "开始年月",
        "comment": "开始年月",
        "class": "col-lg-4 col-sm-6 col-xs-12",
        "placeholder": "开始年月",
        "model": null,
        "visible": true,
        "require": true,
        "disable": [
          "audit"
        ],
      },
      {
        "column": "YEAR_MONTH_END",
        "name": "YEAR_MONTH_END_NAME",
        "component": "dateMonths",
        "lable": "结束年月",
        "comment": "结束年月",
        "class": "col-lg-4 col-sm-6 col-xs-12",
        "placeholder": "结束年月",
        "model": null,
        "visible": true,
        "require": true,
        "disable": [
          "audit"
        ],
      },
      {
        "column": "TARGET_STATE",
        "name": "TARGET_STATE_NAME",
        "component": "select",
        "lable": "状态",
        "class": "col-lg-4 col-sm-6 col-xs-12",
        "comment": "状态",
        "placeholder": "状态",
        "model": "ADD",
        "require": false,
        "dictionary": "JieLiv2/basic/dict/TARGET_STATE.json",
        "dictionaryPF": null,
        "visible": false
      }
    ]
  };

  //按钮和输入框状态
  btnAndInputState = {
    targetSaveVisit: false,//保存
    auditVisit: false,//审核
    addTargetBtnVisit: false,//结算明细新增按钮
    deleteTargetBtnVisit: false,//结算明细删除按钮
  }

  // 项目顺序是否能调整
  canMove = true;

  //结算明细
  msTranBusinessTargetDetail: any = [];
  //结算类型明细
  calculationType:any = [];

  public addCustTargetVisible = false;
  // 新增客户目标时查询项目期间防止重复点击
  public addCustTargetLoading = false;

  addCustTargetModalForm: any = {
    "tablename": "basic_company",
    "formname": "basic_company",
    "title": "客户简称查询",
    "type": "normal",
    "columns": [
      {
        "column": "COM_SHORT_NAME",
        "name": "COM_SHORT_NAME_NAME",
        "component": "input",
        "lable": "客户简称",
        "comment": "客户简称",
        "class": "col-lg-4 col-sm-6 col-xs-12",
        "placeholder": "请输入客户简称",
        "model": null,
        "visible": true,
        "require": false
      }
    ]
  }

  // orderNum = 1;


  /**
   * 弹出框
   */
  //明细全选
  public allCheckedmsTranBusinessTargetDetail = false;
  public indeterminatemsTranBusinessTargetDetail = false;
  public modalDatas;
  // 分页下标
  public pageIndexModal: any = 1;
  // 每页显示数据
  public pageSizeModal: any = this.appConfigService.config.pageCount;
  // 总条数
  public totalModal: any = 1;
  public nzPageSizeOptionsModal: any = [10, 20, 30, 50, 100, 200];
  //弹窗的有值的条件
  private modalConditionList: any[];


  constructor(
    private dataCenterService: DataCenterService,
    private appConfigService: AppConfigService,
    private requestService: RequestDataService,
    private utils: UtilsService,
    private confirmModal: ConfirmModalService,
    private modalService: NzModalService,
    private userInfoService: UserInfoService
  ) {
  }

  round(num, digits = 2) {
    return Math.round(num * 10 ** digits) / 10 ** digits;
  }

  // 返回
  gotoBack(): void {
    this.parentData.data = {};
    this.parentData.conditionColumns = {};
    this.parentData.formType = 'listForm';
    this.parentData.actionArray = [];
    this.dataCenterService.refreshDataCenterInStorage();
  }

  searchFilterModal(reset: boolean = true) {
    let condition = {};
    this.searchDataModal(reset, condition);
  }

  //弹窗数据
  searchDataModal(reset: boolean, condition?: {}) {
    if (reset) {
      this.pageIndexModal = 1;
    }
    const search01$ = observableForkJoin(
      this.requestService.getPaginationData('/JieLiv2/basic/dict/BASIC_CUST_SHORT_NAME_DICT.json', condition, this.pageIndexModal, this.pageSizeModal),
    );
    search01$.subscribe(
      values => {
        this.modalDatas = _sh.get(values, [0, 'data'], []);//表格数据
        this.totalModal = _sh.get(values, [0, 'page', 'rowCount'], 0);//总页数
        this.pageIndexModal = _sh.get(values, [0, 'page', 'pageNum'], 0);//当前页
        //显示弹窗
        this.addCustTargetVisible = true;
      }
    );
  }

  //过滤按钮
  searchFilter() {
    this.modalConditionList = this.transformCondition(this.addCustTargetModalForm['columns']);
    let condition = {};
    _.each(this.modalConditionList, (item) => {
      // 如果是daterange 类型需要将字段从bindColumns中取出
      if (_.contains(['dateRange', 'dateTimeRange'], item['component'])) {
        _.each(item.code, (value, index) => {
          const column = item['bindColumns'][index];
          condition[column] = value;
        });
      } else {
        condition[item.column] = item.code;
      }
    });
    this.searchDataModal(true, condition);
  }

  // 合并查询条件
  transformCondition(columns) {
    let condition = [];
    _.each(columns, (item) => {
      if (this.utils.Base_HasValue(item['model'])) {
        /**
         * [obj 查询条件对象]
         * column 字段值对应数据库字段
         * label 标题
         * code 查询字段值
         * name 查询字段显示值用于字典
         * @type {Object}
         */
        let obj = {
          column: item['column'],
          title: item['lable'],
          code: item['model'],
          name: item['model'],
          component: item['component']
        };
        if (_.contains(['select', 'poplist', 'inputDataFilter'], item['component'])) {
          const selected = _.find(item['itemArray'], (v) => {
            return v['code'] === item['model'];
          });
          obj['name'] = selected['name'];
        } else if (_.contains(['multiSelect', 'multipopCondition'], item['component'])) {
          let nameList = [];
          _.each(item['itemArray'], (v) => {
            if (_.contains(item['model'], v['code'])) {
              nameList.push(v['name']);
            }
          });
          obj['name'] = nameList.join(' ');
        } else if (_.contains(['dateRange', 'dateTimeRange'], item['component'])) {
          obj['name'] = item['model'].join('~');
          obj['bindColumns'] = item['bindColumns'];
        }
        condition.push(obj);
      }
    });
    return condition;
  }

  resetFilter() {
    _.each(this.addCustTargetModalForm['columns'], (item) => {
      item['model'] = null;
    });
    this.searchFilter();
  }

  //选择一条客户数据数据
  selectOneModalData(oneModalData) {
    //  判断这个调度单，是否在 this.msTranBusinessTargetDetail 里面了，如果在报错。
    let check = true;
    this.msTranBusinessTargetDetail.forEach((item) => {
      if (item.CUST_ID && item.CUST_ID == oneModalData.code) {
        check = false;
      }
    })
    //  如果不在，先查询该客户的项目，有项目再添加并关闭。
    if (check) {
      // 查询项目期间防止重复点击导致重复添加
      if (this.addCustTargetLoading) {
        return;
      }
      this.addCustTargetLoading = true;
      observableForkJoin(
        this.requestService.getDataByCondition(this.appConfigService.config.sql_path + '/ms/tran_business_target_add_project.json', { 'CUST_ID': oneModalData.code }),
      ).subscribe(res => {
        this.addCustTargetLoading = false;
        // 过滤掉无有效项目（PRO_ID 为空）的记录，如“未指定”
        let projects = (_sh.get(res, [0, 'data']) || []).filter((item) => item.PRO_ID);
        // 客户没有项目时阻止添加
        if (projects.length === 0) {
          this.confirmModal.show('error', {
            'title': '执行错误',
            'content': "该客户为无项目组"
          });
          return;
        }
        oneModalData['checked'] = false;
        oneModalData['CUST_ID'] = oneModalData['code'];
        oneModalData['PRO_NAME'] = oneModalData['name'] + '小计';
        let calculationType =  (oneModalData['COM_TYPE']==='CUSTOMER')?1:0;
        oneModalData['CALCULATION_TYPE'] = calculationType;
        oneModalData['level'] = 1;
        oneModalData['background-color'] = "yellow";
        oneModalData['input'] = false;
        // this.orderNum += 1;
        // oneModalData['REPORT_ORDER'] = this.orderNum;
        this.msTranBusinessTargetDetail.push(oneModalData);
        this.addCustTargetVisible = false;
        projects.forEach((item) => {
          // this.orderNum += 1;
          // item['REPORT_ORDER'] = this.orderNum;
          item['CALCULATION_TYPE'] = calculationType;
          item['level'] = 2;
          item['input'] = true;
          // 新增明细时目标收入、税后毛利率默认填 0
          item['TARGET_REVENUE'] = 0;
          item['TARGET_POST_TAX_GROSS_MARGIN'] = 0;
          // 触发一次计算，联动算出税金、资金占用、税后毛利、成本占比
          this.ccalcularOneColumn(item);
          this.msTranBusinessTargetDetail.push(item);
        })
        // 刷新客户小计与总计
        this.calcularSummary();
      }, () => {
        this.addCustTargetLoading = false;
      })
    } else {
      this.confirmModal.show('error', {
        'title': '执行错误',
        'content': "该客户已经添加到明细中，无需反复添加！"
      });
    }
  }


  calcularSummary() {
    let TARGET_REVENUE = 0;
    let TARGET_TAX_AMOUNT = 0;
    let TARGET_CAPITAL_OCCUPATION = 0;
    let TARGET_POST_TAX_GROSS_PROFIT = 0;
    let SUM_TARGET_REVENUE = 0;
    let SUM_TARGET_TAX_AMOUNT = 0;
    let SUM_TARGET_CAPITAL_OCCUPATION = 0;
    let SUM_TARGET_POST_TAX_GROSS_PROFIT = 0;
    for(let i = this.msTranBusinessTargetDetail.length-1; i > 0; i--){
      let OneData = this.msTranBusinessTargetDetail[i];
      if(OneData.level === 2) {
          TARGET_REVENUE += _sh.get(OneData, ['TARGET_REVENUE'], 0);
          TARGET_TAX_AMOUNT += _sh.get(OneData, ['TARGET_TAX_AMOUNT'], 0);
          TARGET_CAPITAL_OCCUPATION += _sh.get(OneData, ['TARGET_CAPITAL_OCCUPATION'], 0);
          TARGET_POST_TAX_GROSS_PROFIT += _sh.get(OneData, ['TARGET_POST_TAX_GROSS_PROFIT'], 0);
      }else{
          OneData.TARGET_REVENUE = this.round(TARGET_REVENUE);
          OneData.TARGET_TAX_AMOUNT = this.round(TARGET_TAX_AMOUNT);
          OneData.TARGET_CAPITAL_OCCUPATION = this.round(TARGET_CAPITAL_OCCUPATION);
          OneData.TARGET_POST_TAX_GROSS_PROFIT = this.round(TARGET_POST_TAX_GROSS_PROFIT);
          OneData.TARGET_POST_TAX_GROSS_MARGIN = TARGET_REVENUE === 0 ? 0 : this.round(TARGET_POST_TAX_GROSS_PROFIT / TARGET_REVENUE,4);
          OneData.TARGET_COST_RATIO = this.round(1 - OneData.TARGET_POST_TAX_GROSS_MARGIN - 0.0926 - 0.015,4);
          SUM_TARGET_REVENUE += TARGET_REVENUE;
          SUM_TARGET_TAX_AMOUNT += TARGET_TAX_AMOUNT;
          SUM_TARGET_CAPITAL_OCCUPATION += TARGET_CAPITAL_OCCUPATION;
          SUM_TARGET_POST_TAX_GROSS_PROFIT += TARGET_POST_TAX_GROSS_PROFIT;
          TARGET_REVENUE = 0;
          TARGET_TAX_AMOUNT = 0;
          TARGET_CAPITAL_OCCUPATION = 0;
          TARGET_POST_TAX_GROSS_PROFIT = 0;
      }
    }
    let OneData = this.msTranBusinessTargetDetail[0];
    OneData.TARGET_REVENUE = this.round(SUM_TARGET_REVENUE);
    OneData.TARGET_TAX_AMOUNT = this.round(SUM_TARGET_TAX_AMOUNT);
    OneData.TARGET_CAPITAL_OCCUPATION = this.round(SUM_TARGET_CAPITAL_OCCUPATION);
    OneData.TARGET_POST_TAX_GROSS_PROFIT = this.round(SUM_TARGET_POST_TAX_GROSS_PROFIT);
    OneData.TARGET_POST_TAX_GROSS_MARGIN = SUM_TARGET_REVENUE === 0 ? 0 : this.round(SUM_TARGET_POST_TAX_GROSS_PROFIT / SUM_TARGET_REVENUE,4);
    OneData.TARGET_COST_RATIO = this.round(1 - OneData.TARGET_POST_TAX_GROSS_MARGIN - 0.0926 - 0.015,4);
  }

  refreshStatusmsTranBusinessTargetDetail(): void {
    const allChecked = this.msTranBusinessTargetDetail.length > 0 && this.msTranBusinessTargetDetail.every(value => value.checked === true);
    const allUnChecked = this.msTranBusinessTargetDetail.every(value => !value.checked);
    this.allCheckedmsTranBusinessTargetDetail = allChecked;
    this.indeterminatemsTranBusinessTargetDetail = (!allChecked) && (!allUnChecked);
  }

  checkAllmsTranBusinessTargetDetail(value: boolean): void {
    this.msTranBusinessTargetDetail.forEach((data, index) => {
      if (index>0)
        data['checked'] = value;
    });
    this.refreshStatusmsTranBusinessTargetDetail();
  }

  //获取ids
  formatSelectEntity(datas, pColumn) {
    let entity: any = [];
    _.each(datas, (OneData) => {
      let obj: any = {};
      const keys = _.keys(OneData);
      _.each(keys, (oneKeys) => {
        if (oneKeys === pColumn) {
          obj['id'] = OneData[oneKeys];
        }
      });
      entity.push(obj);
    });
    return entity;
  }

  getValueFromData(_form, _columns) {

    let findValue = null;

    if (this.parentData.modeType == "add" || this.parentData.modeType == "audit") {
      _sh.each(_form.columns, oneColumn => {
        if (oneColumn.column == _columns) {
          findValue = oneColumn.model;
        }
      });
    } else if (this.parentData.modeType == "modify" || this.parentData.modeType == "revise") {

      _sh.each(_form.columns, oneColumn => {
        if (oneColumn.component == "poplist") {//如果是点击框
          // modelName
          if (oneColumn.column == _columns) {

            //把column中 id返回
            findValue = oneColumn[`${oneColumn['column']}_USERID`];
            if (oneColumn['column'] == "LOADING_AND_UNLOADING_TEAM_NAME") {
              findValue = oneColumn['LOADING_AND_UNLOADING_TEAM_ID'];
            }
          }
        } else {//如果是点击输入框
          // model
          if (oneColumn.column == _columns) {
            findValue = oneColumn.model;
          }
        }
      });

    }
    return findValue;
  }

  // 保存
  targetSave() {
    if (!this.checkData()) {
      return;
    }

    let interfaceBody = {
      msTranBusinessTarget: {
        targetId: this.getValueFromData(this.msTranBusinessTargetForm, 'TARGET_ID'),
        yearMonthStart: this.getValueFromData(this.msTranBusinessTargetForm, 'YEAR_MONTH_START'),
        yearMonthEnd: this.getValueFromData(this.msTranBusinessTargetForm, 'YEAR_MONTH_END'),
        addUserid: this.userInfoService.getUserInfo().USER_ID,
        updUserid: this.userInfoService.getUserInfo().USER_ID,
      },
      msTranBusinessTargetDetailList: [],
    }
    _sh.each(this.msTranBusinessTargetDetail, (oneRow,index) => {
      interfaceBody.msTranBusinessTargetDetailList.push({
        "reportOrder":index+1,
        "expenditureAmount": oneRow['EXPENDITURE_AMOUNT'],
        "custId": oneRow['CUST_ID'],
        "proId": oneRow['PRO_ID'],
        "proName": oneRow['PRO_NAME'],
        "calculationType": oneRow['CALCULATION_TYPE'],
        "targetRevenue": oneRow['TARGET_REVENUE'],
        "targetCostRatio": oneRow['TARGET_COST_RATIO'],
        "targetTaxAmount": oneRow['TARGET_TAX_AMOUNT'],
        "targetCapitalOccupation": oneRow['TARGET_CAPITAL_OCCUPATION'],
        "targetPostTaxGrossProfit": oneRow['TARGET_POST_TAX_GROSS_PROFIT'],
        "targetPostTaxGrossMargin": oneRow['TARGET_POST_TAX_GROSS_MARGIN']
      })
    })

    //修改
    if (this.parentData.modeType == "modify") {
      // let queryData = {
      //   'id': this.parentData.id
      // }
      this.requestService.doActionByHdbsthor("AppApi/MsTranBusinessTargetController", "modifyTarget", {}, interfaceBody, false, 'hdbsthor_JieLiv2', 'appToken').subscribe(res => {
        if (res.status == 500) {
          this.confirmModal.show('error', {
            'title': '执行错误',
            'content': res.error.message
          });
        } else if (res) {
          this.gotoBack();
          this.confirmModal.show('success', {
            'title': '保存成功',
          });
        }
      });
    }

    //修订
    if (this.parentData.modeType == "revise") {
      // let queryData = {
      //   'id': this.parentData.id
      // }
      this.requestService.doActionByHdbsthor("AppApi/MsTranBusinessTargetController", "reviseTarget", {}, interfaceBody, false, 'hdbsthor_JieLiv2', 'appToken').subscribe(res => {
        if (res.status == 500) {
          this.confirmModal.show('error', {
            'title': '执行错误',
            'content': res.error.message
          });
        } else if (res) {
          this.gotoBack();
          this.confirmModal.show('success', {
            'title': '保存成功',
          });
        }
      });
    }

    //新增
    if (this.parentData.modeType == "add") {
      this.requestService.doActionByHdbsthor("AppApi/MsTranBusinessTargetController", "addTarget", {}, interfaceBody, false, 'hdbsthor_JieLiv2', 'appToken').subscribe(res => {
        if (res.status == 500) {
          this.confirmModal.show('error', {
            'title': '执行错误',
            'content': res.error.message
          });
        } else if (res) {
          this.gotoBack();
          this.confirmModal.show('success', {
            'title': '保存成功',
          });
        }
      });
    }
  }

  //整理保存/新增数据
  formatMainToEntity(pForm) {
    let entity: any = {};
    _sh.each(pForm, (item) => {
      const column = _sh.camelCase(_sh.get(item, 'column'));
      entity[column] = _sh.get(item, 'model');
      let columnGroup = _sh.get(item, 'columnGroup', null);
      _sh.each(columnGroup, (oneGroupColumn) => {
        const itemColumn = _sh.camelCase(_sh.get(oneGroupColumn, 'column'));
        entity[itemColumn] = _sh.get(oneGroupColumn, 'model');
      });
    });
    return entity;
  }

  //必填项校验
  checkInput() {
    let result = true;
    _sh.each(this.msTranBusinessTargetForm['columns'],item => {
      if (result && item['require'] == true && !this.utils.Base_HasValue(item['model'])) {
        result = false;
        this.confirmModal.show('error', { 'title': '必填项', 'content': item['comment'] + '为必填项' });
        return false;
      }
    })
    return result;
  }

  //反写值到输入框
  // pForm 表  pDataArray 请求到的
  backfillData(pForm, pDataArray) {
    _.each(pDataArray, oneData => {
      _.each(pForm['columns'], oneColumn => {
        oneColumn['model'] = oneData[oneColumn['column']];

        oneColumn[`${oneColumn['column']}_USERID`] = oneData[`${oneColumn['column']}_USERID`]

        if (oneColumn['column'] == "LOADING_AND_UNLOADING_TEAM_NAME") {
          oneColumn['LOADING_AND_UNLOADING_TEAM_ID'] = oneData['LOADING_AND_UNLOADING_TEAM_ID'];
        }


        // oneColumn[`${pForm['columns']}_USERID`] = oneData[oneColumn[`${pForm['columns']}_USERID`]];

        //每一个column对应的id也得有值
        if (_.contains(['poplist', 'poplistedit', 'cascader'], oneColumn['component'])) {
          oneColumn['modelName'] = oneData[oneColumn['column'] + '_DICT'];
        }

        if (oneColumn['component'] == 'file') {
          let url = oneData[oneColumn['column']];
          let fileName = this.utils.Base_getFileNameOnly(url);
          oneColumn['fileList'] = [];
          oneColumn['fileList'].push(
            {
              uid: this.utils.Base_getUuid(),
              name: fileName,
              status: 'done',
              url: url
            }
          )
        }
        _.each(oneColumn['columnGroup'], oneColumnGroup => {
          oneColumnGroup['model'] = oneData[oneColumnGroup['column']];
          if (_.contains(['poplist', 'poplistedit', 'cascader'], oneColumnGroup['component'])) {
            oneColumnGroup['modelName'] = oneData[oneColumnGroup['column'] + '_DICT'];
          }
        })
      })
    })
  }

  async ngOnInit() {
    //按钮和输入框的权限
    this.updateVisit();
    // 载入计算类型
    const res = observableForkJoin(
      this.requestService.getPaginationData(this.appConfigService.config.sql_path + '/basic/CALCULATION_TYPE.json', {}),
    );
    res.subscribe(
      values => {
        this.calculationType = _sh.get(values, [0, 'data']);
      }
    );
    let modeType = this.parentData.modeType;
    if (modeType == "modify" || modeType == "revise" || modeType == "audit") {
      const res = await observableForkJoin(
        this.requestService.getDataByCondition(this.appConfigService.config.sql_path + '/ms/tran_business_target_detail.json', { 'TARGET_ID': this.parentData.id }),//配送业务目标管理
        this.requestService.getDataByCondition(this.appConfigService.config.sql_path + '/ms/tran_business_target_detail_detail.json', { 'TARGET_ID': this.parentData.id }),//配送业务目标明细
      ).toPromise();

      //填充主表数据
      // oneColumn['modelName'] = oneData[oneColumn['column'] + '_DICT'];
      // res[0]['data'][0]['COUNT_ACTOR_DICT'] = res[0]['data'][0]['COUNT_ACTOR'];//经手人

      // this.msTranBusinessTargetForm.columns[4].modelName = "1212";
      // 获取仓储作业支出结算管理
      this.backfillData(this.msTranBusinessTargetForm, res[0]['data']);

      // 结算明细
      this.msTranBusinessTargetDetail = _sh.get(res, [1, 'data']);
      this.msTranBusinessTargetDetail.forEach((item, index) => {
        item['checked'] = false;
        item['input'] = false; //是否可以输入
        if (item['CUST_ID'])
          if (item['PRO_ID']) {
            item['level'] = 2;
            if (modeType == "modify") item['input'] = true;
          }else{
            item['level']=1
            item['background-color'] = "yellow";
          }
        else{
          item['level']=0
          item['background-color'] = "deepskyblue";
        }
      })
      this.calcularSummary();
      // this.orderNum = this.msTranBusinessTargetDetail.length;
    }else{
      let oneModalData: any = {};
      oneModalData['checked'] = false;
      oneModalData['level'] = 0;
      oneModalData['background-color'] = "deepskyblue";
      oneModalData['PRO_NAME'] = "总计";
      oneModalData['CALCULATION_TYPE'] = 1;
      // oneModalData['REPORT_ORDER'] = 1;
      oneModalData['input'] = false;
      this.msTranBusinessTargetDetail.push(oneModalData);
    }
  }

  //审核
  targetAudit() {
    if (!this.checkData()) {
      return;
    }

    this.confirmModal.show('confirm', {
      title: '确认审核该结算单吗？',
      suc: () => {
        let queryData = {
          'id': this.parentData.id,
          'updUserId': this.userInfoService.getUserInfo().USER_ID
        }

        this.requestService.doActionByHdbsthor("AppApi/MsTranBusinessTargetController", "auditTarget", queryData, {}, false, 'hdbsthor_JieLiv2', 'appToken').subscribe(res => {
          if (res.status == 500) {
            this.confirmModal.show('error', {
              'title': '执行错误',
              'content': res.error.message
            });
          } else if (res) {
            this.gotoBack();
            this.confirmModal.show('success', {
              'title': '审核成功',
            });
          }
        });
      }
    });
  }

  //检查数据
  checkData() {

    //必填字段
    if (!this.checkInput()) {
      return false;
    }

    //起始时间逻辑
    if (this.msTranBusinessTargetForm['columns'][1].model > this.msTranBusinessTargetForm['columns'][2].model) {
      this.confirmModal.show('error', {
        'title': '执行错误',
        'content': "起始时间不能大于结束时间！"
      });
      return false;
    }

    //检查结算明细数据
    if (this.msTranBusinessTargetDetail.length <= 1) {
      this.confirmModal.show('error', {
        'title': '执行错误',
        'content': "请添加至少一条客户目标！"
      });
      return false;
    }

    //必填数据检查
    let amountFlag = false;
    _sh.each(this.msTranBusinessTargetDetail, (item) => {
      if (item['TARGET_REVENUE'] === null || item['TARGET_REVENUE'] === "" ) {
        this.confirmModal.show('error', {
          'title': '执行错误',
          'content': "项目名称为" + item['PRO_NAME'] + "的目标收入为空！"
        });
        amountFlag = true;
        return false;
      }
      if  (!Number.isNaN(item['TARGET_POST_TAX_GROSS_MARGIN']) && (item['TARGET_POST_TAX_GROSS_MARGIN'] === null || item['TARGET_POST_TAX_GROSS_MARGIN'] === "" )){
        this.confirmModal.show('error', {
          'title': '执行错误',
          'content': "项目名称为" + item['PRO_NAME'] + "的税后毛利率为空！"
        });
        amountFlag = true;
        return false;
      }
    })
    return !amountFlag;
  }

  //按钮和输入框的权限
  updateVisit() {
    // 根据按钮的类型区分
    // this.parentData.modeType
    if (this.parentData.modeType == 'add' || this.parentData.modeType == 'modify' || this.parentData.modeType == 'revise') {//添加修改
      this.btnAndInputState.targetSaveVisit = true;
      this.btnAndInputState.addTargetBtnVisit = true;
      this.btnAndInputState.deleteTargetBtnVisit = true;
      // this.formVisable(['结算单号','结算序号'], false, false);
    } else if (this.parentData.modeType == 'audit') {//审核
      this.btnAndInputState.auditVisit = true;
      this.canMove = false;
    }
  }

  addTarget() {
    const search01$ = observableForkJoin(
      this.requestService.getPaginationData('/JieLiv2/basic/dict/BASIC_CUST_SHORT_NAME_DICT.json', {}, this.pageIndexModal, this.pageSizeModal),
    );
    search01$.subscribe(
      values => {
        this.modalDatas = _sh.get(values, [0, 'data'], []);
        this.totalModal = _sh.get(values, [0, 'page', 'rowCount'], 0);
        this.pageIndexModal = _sh.get(values, [0, 'page', 'pageNum'], 0);
        //显示弹窗
        this.addCustTargetVisible = true;
      }
    );
  }

  deleteTarget() {
    let del2 = false;
    for(let i = 1; i < this.msTranBusinessTargetDetail.length; i++){
      let OneData = this.msTranBusinessTargetDetail[i];
      if (OneData.level === 1) {
        del2 = OneData.checked;
      } else {
        if (del2) OneData.checked = true;
      }
    }
    this.msTranBusinessTargetDetail = this.msTranBusinessTargetDetail.filter((e) => {
      return !e.checked;
    });
    // this.orderNum = this.msTranBusinessTargetDetail.length;
    // _sh.each(this.msTranBusinessTargetDetail, item => {
    //   item['REPORT_ORDER'] = item.index + 1;
    // })
    this.calcularSummary();
  }

  ccalcularOneColumn(OneData){
    if (OneData.TARGET_REVENUE != null && OneData.TARGET_REVENUE !== "" &&
      OneData.TARGET_POST_TAX_GROSS_MARGIN != null &&
      OneData.TARGET_POST_TAX_GROSS_MARGIN !== "") {
      OneData.TARGET_REVENUE = this.round(OneData.TARGET_REVENUE);
      OneData.TARGET_POST_TAX_GROSS_MARGIN = this.round(OneData.TARGET_POST_TAX_GROSS_MARGIN,4);
      if (OneData.CALCULATION_TYPE===1)
        OneData.TARGET_COST_RATIO = this.round(1 - OneData.TARGET_POST_TAX_GROSS_MARGIN - 0.0926 - 0.015,4)
      else
        OneData.TARGET_COST_RATIO = 0;
      OneData.TARGET_TAX_AMOUNT = this.round(OneData.TARGET_REVENUE * 0.0926);
      OneData.TARGET_CAPITAL_OCCUPATION = this.round(OneData.TARGET_REVENUE * 0.01 * 1.5);
      OneData.TARGET_POST_TAX_GROSS_PROFIT = this.round(OneData.TARGET_REVENUE * OneData.TARGET_POST_TAX_GROSS_MARGIN);
      return true;
    }
    return false;
  }

  inputChange($event,OneData) {
    if (this.ccalcularOneColumn(OneData))
      this.calcularSummary();
  }

  calculationTypeChange($event,oneColumn){
    let flag = false;
    let i = this.msTranBusinessTargetDetail.indexOf(oneColumn)+1;
    while (i<this.msTranBusinessTargetDetail.length && this.msTranBusinessTargetDetail[i].kevel===2){
      this.msTranBusinessTargetDetail[i].CALCULATION_TYPE = oneColumn.CALCULATION_TYPE;
      if (this.ccalcularOneColumn(this.msTranBusinessTargetDetail[i]))
        flag = true;
      i++;
    }
    if (flag) this.calcularSummary();
  }

  // 放到第一位
  // pubItFirst(oneColumn: any) {
  //   if (oneColumn.level === 1){
  //
  //   } else {
  //
  //   }
  //   this.msTranBusinessTargetDetail = _.without(this.msTranBusinessTargetDetail, oneColumn);
  //   this.msTranBusinessTargetDetail.unshift(oneColumn);
  // }

  putForward(oneColumn) {
    let num = this.msTranBusinessTargetDetail.indexOf(oneColumn);
    if (oneColumn.level === 1){
      // 找到上一个客户开始的下标
      let f = num-1;
      while (this.msTranBusinessTargetDetail[f].level === 2) f--;
      if (f>0){
        // 找到操作客户结束的下标
        let m = 1;
        while (num+m<this.msTranBusinessTargetDetail.length && this.msTranBusinessTargetDetail[num+m].level === 2) m++;
        const slice = this.msTranBusinessTargetDetail.splice(num, m);
        this.msTranBusinessTargetDetail.splice(f, 0, ...slice);
      }
    } else {
      let a = this.msTranBusinessTargetDetail[num - 1];
      if (a.level === 2) {
        this.msTranBusinessTargetDetail[num - 1] = oneColumn;
        this.msTranBusinessTargetDetail[num] = a;
      }
    }
  }

  putItBack(oneColumn) {
    let num = this.msTranBusinessTargetDetail.indexOf(oneColumn);
    if (oneColumn.level === 1){
      // 找到下一个客户开始的下标
      let m = 1;
      while (num+m<this.msTranBusinessTargetDetail.length && this.msTranBusinessTargetDetail[num+m].level === 2) m++;
      if (num+m<this.msTranBusinessTargetDetail.length) {
        const slice = this.msTranBusinessTargetDetail.splice(num, m);
        let d = num + 1;
        while (d<this.msTranBusinessTargetDetail.length && this.msTranBusinessTargetDetail[d].level === 2) d++;
        this.msTranBusinessTargetDetail.splice(d, 0, ...slice);
      }
    }else {
      let a = this.msTranBusinessTargetDetail[num + 1];
      if (a.level === 2) {
        this.msTranBusinessTargetDetail[num + 1] = oneColumn;
        this.msTranBusinessTargetDetail[num] = a;
      }
    }
  }


  // pubItLast(oneColumn) {
  //   this.msTranBusinessTargetDetail = _.without(this.msTranBusinessTargetDetail, oneColumn);
  //   this.msTranBusinessTargetDetail.push(oneColumn);
  // }
}

